export const EstadoDetalleEnvio = {
    NOTIFICACION_CORRECTA: "1",
    VISUALIZADO_FIRMADO: "8",
    VISUALIZADO_PENDIENTE_FIRMAR: "7",
    NOTIFICACION_EN_PROCESO: "0"
}